module.exports = __webpack_public_path__ + "img/sandrapeter.faab71c3.jpg";